import { render, staticRenderFns } from "./DefaultHeader.vue?vue&type=template&id=d631c69a&scoped=true"
import script from "./DefaultHeader.vue?vue&type=script&lang=js"
export * from "./DefaultHeader.vue?vue&type=script&lang=js"
import style0 from "./DefaultHeader.vue?vue&type=style&index=0&id=d631c69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d631c69a",
  null
  
)

export default component.exports